// extracted by mini-css-extract-plugin
export default {"lawyerCard":"LawyerCard_lawyerCard__gQxyw","img":"LawyerCard_img__q4zfE","name":"LawyerCard_name__M48C3","title":"LawyerCard_title__gcsuf"};